'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoMagnet = function IoMagnet(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 2.5c9 0 15 6.1 15 15.6 0 3.9-0.2 6-1.2 10-1.2 5.2-3 8.9-3 8.9v0c-0.2 0.3-0.5 0.5-0.8 0.5-0.1 0-0.2-0.1-0.3-0.1l-0.2-0.1-3.9-1.5-0.1-0.1c-0.3-0.2-0.4-0.4-0.4-0.7 0-0.1 0-0.2 0.1-0.3v-0.1c0.5-1.2 2.1-4.6 2.8-7.9s1.1-4.9 1.1-8.4c0-5.6-4.1-9.5-9.1-9.5s-9.1 3.9-9.1 9.5c0 3.5 0.3 5.1 1.1 8.4s2.3 6.7 2.8 7.9v0.1c0.1 0.1 0.1 0.2 0.1 0.3 0 0.3-0.1 0.5-0.4 0.7l-0.1 0.1-3.9 1.5-0.2 0.1c-0.1 0-0.2 0.1-0.3 0.1-0.3 0-0.6-0.2-0.8-0.5v0s-1.9-3.7-3.1-8.9c-0.9-4-1.1-6.1-1.1-10 0-9.5 6-15.6 15-15.6z m-6.5 32.2c-0.7-1.5-2.1-4.6-2.8-7.7l-3.3 1c1 4.1 2.4 7.2 2.8 8.1l3.3-1.3v-0.1z m16.3 1.4c0.4-0.9 1.8-4 2.8-8.1l-3.4-1c-0.7 3.1-2 6.2-2.7 7.7v0.1z' })
        )
    );
};

exports.default = IoMagnet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/magnet.js
// module id = 2345
// module chunks = 0